import EpiComponent from '@episerver/spa-core/EpiComponent';
import React, { ReactNode, ReactNodeArray } from 'react';
import UpgradesPrivateArea from './UpgradesPrivateArea.js';
import UpgradesPrivateAreaBlockData from '../../../Models/Content/UpgradesPrivateAreaBlockData';

export default class UpgradesPrivateAreaBlock extends EpiComponent<UpgradesPrivateAreaBlockData> {

  public render(): ReactNode | ReactNodeArray | null {
    const cssClasses: Array<string> = ['upgrades-private-area-block'];
    if (this.props.data.padding?.value) cssClasses.push(this.props.data.padding?.value);
    if (this.props.data.margin?.value) cssClasses.push(this.props.data.margin?.value);

    return (
      <div className={cssClasses.join(" ")}>
        <UpgradesPrivateArea
          context={this.getContext()}
          iContent={this.props.data}
        />
      </div>
    );
  };
};
